import { z } from 'zod';

export const storeFormSchema = z.object({
  name: z.string().min(1, 'Nome da loja é obrigatório'),
  dealerName: z.string().min(1, 'Nome do dealer é obrigatório'),
  state: z.string().min(2, 'UF deve ter 2 caracteres').max(2, 'UF deve ter 2 caracteres'),
  city: z.string().min(1, 'Cidade é obrigatória'),
  street: z.string().min(1, 'Rua é obrigatória'),
  number: z.string().min(1, 'Número é obrigatório'),
  neighborhood: z.string().min(1, 'Bairro é obrigatório'),
  zipCode: z.string().regex(/^\d{5}-\d{3}$/, 'CEP inválido (ex: 01234-567)'),
  phone: z.string().regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, 'Telefone inválido (ex: (11) 99999-9999)'),
  whatsapp: z.string().regex(/^\(\d{2}\) \d{4,5}-\d{4}$/, 'WhatsApp inválido (ex: (11) 99999-9999)'),
  email: z.string().email('Email inválido'),
  parallelAppointments: z.number().int().min(1, 'Mínimo 1').max(10, 'Máximo 10'),
  latitude: z.number().min(-90).max(90).optional(),
  longitude: z.number().min(-180).max(180).optional(),
});

export type StoreFormData = z.infer<typeof storeFormSchema>;
